import {Editor, HtmlEditorServices} from '@frontapp/editor-html';

import {globalWindow} from '../../../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {BaseChangeManager} from './baseChangeManager';

/** @deprecated Use createEditorServiceChangeManager(editor.services.html) instead. */
export class HtmlEditorChangeManager extends BaseChangeManager {
  constructor(editor: Editor<HtmlEditorServices>) {
    super({
      subscribe: (subscriber) => {
        const subscription = editor.services.html.changes$.subscribe(subscriber);
        return () => subscription.unsubscribe();
      },
      postChangeHandler: (callback) => globalWindow.setInstrumentedTimeout(callback, 0),
    });
  }
}
